var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { ExternalDepositsService } from '@square/dashboard-protos/models/squareup/deposits/service';
import Service, { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import rpc from '@banking/api/utils/rpc';
import { ExternalBankAccount } from '@square/dashboard-protos/models/squareup/sfs/external/models/external_bank_account';
import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
import { TransferType } from '@square/dashboard-protos/models/squareup/sfs/models/transfer';
import { BalanceActivityType } from '@square/dashboard-protos/models/squareup/deposits/model';
export const CREATE_TRANSFER_URL = '/api/v1/transfers/create-transfer';
export const ELIGIBLE_FOR_INSTANT_DEPOSIT_URL = '/api/v1/transfers/eligible-for-instant-deposit';
let BankingTransferApi = (_dec = computed('capitalEngineContext.headers'), _class = class BankingTransferApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "sfsTransferApi", _descriptor2, this);
  }
  get client() {
    return ExternalDepositsService.create(rpc((method, guessedUrl) => {
      switch (method) {
        case ExternalDepositsService.methods.CreateTransfer:
          return CREATE_TRANSFER_URL;
        case ExternalDepositsService.methods.EligibleForInstantDeposit:
          return ELIGIBLE_FOR_INSTANT_DEPOSIT_URL;
        default:
          return guessedUrl;
      }
    }, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  async createTransfer({
    srcAccount,
    destAccount,
    amount,
    idempotenceKey
  }) {
    if (srcAccount instanceof ExternalBankAccount || destAccount instanceof ExternalBankAccount) {
      // If either of the accounts is a SFS external linked account then just
      // assume the other account is a SavingsAccount.
      const transfer = await this.sfsTransferApi.createTransfer({
        fromAccountId: srcAccount instanceof ExternalBankAccount ? srcAccount.id : srcAccount.metadata?.savingsAccount?.sfsAccountId,
        toAccountId: destAccount instanceof ExternalBankAccount ? destAccount.id : destAccount.metadata?.savingsAccount?.sfsAccountId,
        amount,
        type: TransferType.EXTERNAL_TRANSFER
      }, idempotenceKey);
      if (transfer) {
        return transfer;
      } else {
        throw new Error('transfer was successful but had no data');
      }
    }
    if (srcAccount.type === AccountType.SAVINGS_ACCOUNT && destAccount.type === AccountType.SAVINGS_ACCOUNT) {
      const transfer = await this.sfsTransferApi.createTransfer({
        fromAccountId: srcAccount.metadata?.savingsAccount?.sfsAccountId,
        toAccountId: destAccount.metadata?.savingsAccount?.sfsAccountId,
        amount,
        type: TransferType.SAVINGS_TRANSFER
      }, idempotenceKey);
      if (transfer) {
        return transfer;
      } else {
        throw new Error('transfer was successful but had no data');
      }
    }
    if (srcAccount.type !== AccountType.SAVINGS_ACCOUNT && destAccount.type === AccountType.SAVINGS_ACCOUNT || destAccount.type !== AccountType.SAVINGS_ACCOUNT && srcAccount.type === AccountType.SAVINGS_ACCOUNT) {
      // If one account is a savings account and the other is not then this is
      // a transfer between a savings and a checking account.
      const transfer = await this.client.createTransfer({
        idempotenceKey,
        unitToken: srcAccount.type === AccountType.SAVINGS_ACCOUNT ? destAccount.owner?.id : srcAccount.owner?.id,
        amount,
        balanceActivityType: BalanceActivityType.BALANCE_TRANSFER,
        source: {
          balanceId: srcAccount.id
        },
        destination: {
          balanceId: destAccount.id
        }
      });
      if (transfer.balanceActivity) {
        return {
          id: transfer.balanceActivity.token
        };
      } else {
        throw new Error('transfer was successful but had no data');
      }
    }
    throw new Error('dest & src accounts passed are not a supported combination');
  }
  async isEligibleForInstantDeposit(unitToken) {
    try {
      const response = await this.client.eligibleForInstantDeposit({
        unitToken,
        alwaysShowUnsettleableBlockers: true
      });
      if (response) {
        return response;
      }
      throw new Error('Could not retrieve IT eligibility for user');
    } catch {
      throw new Error('Could not retrieve IT eligibility for user');
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsTransferApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { BankingTransferApi as default };